export const typesCruisefare = {
    GET_CRUISEFARE_SUCCESS:'GET_CRUISEFARE_SUCCESS',
    GET_CRUISEFARE_ERROR:'GET_CRUISEFARE_ERROR',
    GET_CRUISEFARE_BEGIN:'GET_CRUISEFARE_BEGIN'
}
